import { GetServerSideProps } from "next";
import { ProfileAchievementsPage } from "../../features/profile/achievements-page/achievements-page";
import { withLogging } from "../../lib/ssr/logGetServerSideProps";

export default ProfileAchievementsPage;

export const getServerSideProps: GetServerSideProps<
  Awaited<ReturnType<typeof ProfileAchievementsPage.prefetchData>>,
  { usernameOrId: string }
> = withLogging(async (context) => {
  const props = await ProfileAchievementsPage.prefetchData(context.params);

  return {
    props,
  };
});
